(function () {
  if (customElements.get('media-gallery-k')) return;

  class MediaGalleryK extends HTMLElement {
    connectedCallback() {
      this.track  = this.querySelector('.kg__track');
      this.slides = Array.from(this.querySelectorAll('.kg__slide'));
      this.thumbs = Array.from(this.querySelectorAll('.kg__thumb'));
      this.cur    = this.querySelector('.kg__cur');
      this.lb     = this.querySelector('.kg__lb');
      this.lbImg  = this.querySelector('.kg__lbimg');
      if (!this.track) return;

      this.syncOnScroll();
      this.bindThumbs();
      this.bindKeys();
      this.bindZoom();
      this.pauseOffscreenVideo();
    }

    syncOnScroll() {
      const io = new IntersectionObserver((entries) => {
        entries.forEach((e) => {
          if (e.intersectionRatio < 0.6) return;
          const i = Number(e.target.dataset.i);
          if (this.cur) this.cur.textContent = i;
          this.thumbs.forEach((t) => {
            const on = Number(t.dataset.go) === i;
            t.classList.toggle('is-active', on);
            t.setAttribute('aria-selected', on ? 'true' : 'false');
            if (on) t.scrollIntoView({ block: 'nearest', inline: 'nearest' });
          });
        });
      }, { root: this.track, threshold: [0.6] });
      this.slides.forEach((s) => io.observe(s));
    }

    goTo(i) {
      const s = this.slides[i - 1];
      if (s) this.track.scrollTo({ left: s.offsetLeft, behavior: 'smooth' });
    }

    bindThumbs() {
      this.thumbs.forEach((t) => {
        t.addEventListener('click', () => this.goTo(Number(t.dataset.go)));
      });
    }

    bindKeys() {
      this.track.addEventListener('keydown', (e) => {
        const now = Number(this.cur ? this.cur.textContent : 1);
        if (e.key === 'ArrowRight') { e.preventDefault(); this.goTo(Math.min(now + 1, this.slides.length)); }
        if (e.key === 'ArrowLeft')  { e.preventDefault(); this.goTo(Math.max(now - 1, 1)); }
      });
    }

    pauseOffscreenVideo() {
      const vids = this.querySelectorAll('video');
      if (!vids.length) return;
      const io = new IntersectionObserver((entries) => {
        entries.forEach((e) => { if (!e.isIntersecting) e.target.pause(); });
      }, { root: this.track, threshold: 0.4 });
      vids.forEach((v) => io.observe(v));
    }

    bindZoom() {
      if (!this.lb) return;
      const img = this.lbImg;
      let scale = 1, x = 0, y = 0;
      const pts = new Map();
      let startDist = 0, startScale = 1, lastTap = 0;

      const apply = () => {
        img.style.transform = 'translate(' + x + 'px,' + y + 'px) scale(' + scale + ')';
      };
      const reset = () => { scale = 1; x = 0; y = 0; apply(); };

      const open = (src, alt) => {
        img.src = src;
        img.alt = alt || '';
        reset();
        this.lb.showModal();
        document.body.style.overflow = 'hidden';
      };
      const close = () => {
        this.lb.close();
        document.body.style.overflow = '';
      };

      this.querySelectorAll('.kg__zoombtn').forEach((btn) => {
        btn.addEventListener('click', () => {
          const i = btn.querySelector('img');
          open(i.dataset.full || i.currentSrc || i.src, i.alt);
        });
      });

      this.querySelector('.kg__lbclose').addEventListener('click', close);
      this.lb.addEventListener('cancel', close);
      this.lb.addEventListener('click', (e) => { if (e.target === this.lb) close(); });

      img.addEventListener('pointerdown', (e) => {
        img.setPointerCapture(e.pointerId);
        pts.set(e.pointerId, e);
        if (pts.size === 2) {
          const [a, b] = Array.from(pts.values());
          startDist = Math.hypot(a.clientX - b.clientX, a.clientY - b.clientY);
          startScale = scale;
        }
      });

      img.addEventListener('pointermove', (e) => {
        if (!pts.has(e.pointerId)) return;
        const prev = pts.get(e.pointerId);
        pts.set(e.pointerId, e);

        if (pts.size === 2) {
          const [a, b] = Array.from(pts.values());
          const d = Math.hypot(a.clientX - b.clientX, a.clientY - b.clientY);
          scale = Math.min(Math.max(startScale * (d / startDist), 1), 4);
          apply();
        } else if (pts.size === 1 && scale > 1) {
          x += e.clientX - prev.clientX;
          y += e.clientY - prev.clientY;
          apply();
        }
      });

      const up = (e) => { pts.delete(e.pointerId); if (scale <= 1) reset(); };
      img.addEventListener('pointerup', up);
      img.addEventListener('pointercancel', up);

      img.addEventListener('click', () => {
        const now = Date.now();
        if (now - lastTap < 300) {
          scale = scale > 1 ? 1 : 2.5;
          x = 0; y = 0;
          apply();
        }
        lastTap = now;
      });

      img.addEventListener('wheel', (e) => {
        e.preventDefault();
        scale = Math.min(Math.max(scale - e.deltaY * 0.002, 1), 4);
        if (scale === 1) { x = 0; y = 0; }
        apply();
      }, { passive: false });
    }
  }

  customElements.define('media-gallery-k', MediaGalleryK);
})();
